var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.0006C11.6667 7.92419 9.73583 5.83594 7.38095 5.83594C7.10201 5.83594 6.18253 5.83595 5.95238 5.83595C3.58545 5.83595 1.66667 7.70054 1.66667 10.0006C1.66667 11.9826 3.09144 13.6413 5 14.0621C5.3063 14.1297 5.62505 14.1653 5.95238 14.1653",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 10.0006C8.33333 12.077 10.2642 14.1653 12.6191 14.1653C12.898 14.1653 13.8175 14.1653 14.0476 14.1653C16.4146 14.1653 18.3333 12.3007 18.3333 10.0006C18.3333 8.01861 16.9086 6.35998 15 5.93914C14.6937 5.8716 14.3749 5.83594 14.0476 5.83594",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.df8a57f11462df823c6d6a442fed8941.svg";
export { ForwardRef as ReactComponent };